export default "__VITE_ASSET__nhkt5lGe__"